import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import style from "css/realtime.module.css";
import {
  Descriptions,
  Button,
  ConfigProvider,
  Table,
  Modal,
  QRCode,
  Empty,
} from "antd";
import {
  PoweroffOutlined,
  ReloadOutlined,
  AudioOutlined,
  AudioMutedOutlined,
  DisconnectOutlined,
  AppstoreOutlined,
  ExportOutlined,
  CopyOutlined,
  QrcodeOutlined,
  PlusOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { openConfirm, closeAlert, openAlert } from "redux/slices/alertSlice";
import CopyToClipboard from "react-copy-to-clipboard";
import CmsEndpointModal from "./cmsEndpointModal";
import NameModal from "./nameModal";
import CmsLayoutModal from "./cmsLayoutModal";
import CmsAddEndpointModal from "./cmsAddEndpointModal";
import { useTranslation } from "react-i18next";

function CmsDetail(props) {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [participantId, setParticipantId] = useState("");
  const [openLayoutModal, setOpenLayoutModal] = useState(false);
  const closeLayoutModal = () => {
    setOpenLayoutModal(false);
  };
  const [openDetailModal, setOpenDetailModal] = useState(false);
  const closeDetailModal = () => {
    setOpenDetailModal(false);
    setParticipantId("");
  };

  const [openAddEndpointModal, setOpenAddEndpointModal] = useState(false);
  const closeAddEndpointModal = () => {
    setOpenAddEndpointModal(false);
  };

  const [isOpenNameModal, setIsOpenNameModal] = useState(false);
  const [selectedName, setSelectedName] = useState({
    name: "",
    id: "",
  });

  const columns = [
    {
      title: t("LIST.MEETING_ROOM"),
      dataIndex: "display_name",
      key: "display_name",
      align: "center",
      render: (_, el) => (
        <div
          className="cursor"
          onClick={() => {
            setSelectedName({
              name: el.name,
              id: el.id,
            });
            setIsOpenNameModal(true);
          }}
        >
          {el.name}
        </div>
      ),
    },
    {
      title: t("LIST.DEVICE_ADDRESS"),
      dataIndex: "signalling_node",
      key: "signalling_node",
      align: "center",
    },
    {
      title: t("LIST.MUTE"),
      dataIndex: "is_muted",
      key: "is_muted",
      align: "center",
      render: (_, el) =>
        el.mic_mute ? (
          <AudioMutedOutlined
            style={{
              color: "#50c1a1",
              transform: "scaleX(-1)",
            }}
            onClick={() => setMute(el.id, !el.mic_mute)}
          />
        ) : (
          <AudioOutlined
            className="cursor"
            onClick={() => setMute(el.id, !el.is_muted)}
          />
        ),
    },
    {
      title: t("LIST.VIDEO"),
      dataIndex: "video",
      key: "video",
      align: "center",
      render: (_, el) =>
        el.video_mute ? (
          <EyeInvisibleOutlined
            style={{
              color: "#1677ff",
              transform: "scaleX(-1)",
            }}
            onClick={() => {
              setMuteVideo(el.id, !el.video_mute);
            }}
          />
        ) : (
          <EyeOutlined
            className="cursor"
            onClick={() => {
              setMuteVideo(el.id, !el.video_mute);
            }}
          />
        ),
    },
    {
      title: t("LIST.DISCONNECT"),
      dataIndex: "DISCONNECT",
      key: "DISCONNECT",
      align: "center",
      render: (_, el) => (
        <DisconnectOutlined
          style={{ color: "#f5222d" }}
          className="cursor"
          onClick={() => {
            const obj = {
              title: t("MESSAGE.NOTIFICATION"),
              content: t("MESSAGE.DISCONNECT_USER", { USER: el.display_name }),
              submitEventHandler: () => {
                setDisconnect(el.id);
                dispatch(closeAlert());
              },
            };
            dispatch(openConfirm(obj));
          }}
        />
      ),
    },
    {
      title: t("LIST.LAYOUT"),
      dataIndex: "layout",
      key: "layout",
      align: "center",
      render: (_, el) => <>{el.layout}</>,
    },
    {
      title: t("LIST.CONNECTION_TIME"),
      dataIndex: "duration_time",
      key: "duration_time",
      align: "center",
      render: (_, el) => (
        // <>{timeFormat(el.duration_time)}</>
        <DuraionFormat duration={el.duration_time} />
      ),
    },
    {
      title: t("LIST.DETAIL_INFO"),
      dataIndex: "DETAIL",
      key: "DETAIL",
      align: "center",
      render: (_, el) => (
        <ConfigProvider
          theme={{
            token: {
              fontFamily: "Spoqa Han Sans Neo",
            },
            components: {
              Button: {
                colorPrimary: "#def5e9",
                colorTextLightSolid: "#50c1a1",
                colorPrimaryHover: "#def5e9",
              },
            },
          }}
        >
          <Button
            type="primary"
            shape="round"
            onClick={() => {
              setOpenDetailModal(true);
              setParticipantId(el.id);
            }}
          >
            more
            <PlusOutlined />
          </Button>
        </ConfigProvider>
      ),
    },
  ];

  const [loading, setLoading] = useState(false);
  const [meetingDetail, setMeetingDetail] = useState({
    ENVIRONMENT_INFO: {},
    CALL_INFO: {},
    MEETING_ROOM_INFO: {},
    SCHEDULE_INFO: {},
    PARTICIPANTS: [],
  });

  const getMeetingDetail = useCallback(() => {
    let url = "/active/detail";
    let param = {
      params: {
        MEETING_KEY: props.meetingKey,
        SERVER_NO: props.serverNo,
        // SCHEDULE_TYPE: "CD0203",
      },
    };
    setLoading(true);
    axios.get(url, param).then((res) => {
      setLoading(false);
      if (res.status === 200) {
        if (res.data.hasOwnProperty("ERR_MSG")) {
          const obj = {
            title: t("MESSAGE.NOTIFICATION"),
            content: t("MESSAGE.ALREADY_ENDED_MEETING"),
            submitEventHandler: () => {
              dispatch(closeAlert());
              navigate(-1);
            },
          };
          dispatch(openAlert(obj));
        } else {
          setMeetingDetail(res.data);
        }
      } else {
        const obj = {
          title: t("MESSAGE.NOTIFICATION"),
          content: t("MESSAGE.ALREADY_ENDED_MEETING"),
          submitEventHandler: () => {
            dispatch(closeAlert());
            navigate(-1);
          },
        };
        dispatch(openAlert(obj));
      }
    });
  }, [props.meetingKey, props.serverNo, t, dispatch, navigate]);

  // const timeFormat = (duration) => {
  //     let time = "";

  //     const hour = Math.floor(Number(duration) / 3600);
  //     const min = Math.floor((Number(duration) % 3600) / 60);
  //     const second = Math.floor((Number(duration) % 3600) % 60);

  //     time += hour > 0 ? hour + "시간 " : "";
  //     time += min > 0 ? min + "분 " : "";
  //     time += second > 0 ? second + "초" : "";

  //     return time;
  // }

  const setMute = (id, mute) => {
    let url = "/active/mute";
    let param = {
      params: {
        callLegId: id,
        is_mute: mute,
        SERVER_NO: props.serverNo,
      },
    };
    // setMeetingDetail({
    //   ...meetingDetail,
    //   PARTICIPANTS: [],
    // });
    setLoading(true);
    axios.post(url, null, param).then((res) => {
      if (res.status === 200) {
        if (res.data.PARTICIPANTS !== null) {
          setLoading(false);
          setMeetingDetail({
            ...meetingDetail,
            PARTICIPANTS: res.data.PARTICIPANTS,
          });
        }
        getMeetingDetail();
      }
    });
  };

  const setMuteAll = () => {
    let url = "/active/muteAll";

    let particiapntArr = [];
    for (let i = 0; i < meetingDetail.PARTICIPANTS.length; i++) {
      let id = meetingDetail.PARTICIPANTS[i].id;
      particiapntArr.push(id);
    }

    let param = {
      params: {
        PARTICIPANT: particiapntArr.toString().trim(),
        SERVER_NO: props.serverNo,
      },
    };
    // setMeetingDetail({
    //   ...meetingDetail,
    //   PARTICIPANTS: [],
    // });
    setLoading(true);
    axios.post(url, null, param).then((res) => {
      if (res.status === 200) {
        if (res.data.PARTICIPANTS !== null) {
          setLoading(false);
          setMeetingDetail({
            ...meetingDetail,
            PARTICIPANTS: res.data.PARTICIPANTS,
          });
          getMeetingDetail();
        }
      }
    });
  };

  const setMuteVideo = (callLegId, mute) => {
    setLoading(true);

    const data = {
      callLegId: callLegId,
      is_mute: mute,
      SERVER_NO: props.serverNo,
    };

    axios
      .post("/active/video", data)
      .then((res) => {
        if (res.status === 200) {
          getMeetingDetail();
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const setDisconnect = (id) => {
    let url = "/active/disconnect";
    let param = {
      params: {
        callLegId: id,
        SERVER_NO: props.serverNo,
      },
    };
    // setMeetingDetail({
    //   ...meetingDetail,
    //   PARTICIPANTS: [],
    // });
    setLoading(true);
    axios
      .post(url, null, param)
      .then((res) => {
        if (res.status === 200) {
          // if (res.data.PARTICIPANTS !== null) {
          //     // setLoading(false);
          //     // setMeetingDetail({
          //     //     ...meetingDetail,
          //     //     PARTICIPANTS: res.data.PARTICIPANTS,
          //     // });
          // }
          getMeetingDetail();
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const disconnectMeetingRoom = () => {
    let url = "/active/disconnectMeeting";
    let param = {
      params: {
        call_id: meetingDetail.CALL_INFO.call_id,
        cospace_id: meetingDetail.cospace_info.id,
        layout: meetingDetail.cospace_info.layout,
        schedule_id: meetingDetail.CALL_INFO.SCHEDULE_ID,
        SERVER_NO: props.serverNo,
      },
    };

    axios.post(url, null, param).then((res) => {
      if (res.status === 200) {
        const obj = {
          title: t("MESSAGE.NOTIFICATION"),
          content: t("MESSAGE.MEETING_ENDED"),
          submitEventHandler: () => {
            navigate(process.env.REACT_APP_CLIENT_URL + "app/realtime");
            dispatch(closeAlert());
          },
        };
        dispatch(openAlert(obj));
      }
    });
  };

  useEffect(() => {
    if (props.meetingKey !== "") {
      getMeetingDetail();
    }
  }, [getMeetingDetail, props.meetingKey]);

  const [openPop, setopenPop] = useState(false);
  const closePop = () => {
    setopenPop(false);
  };

  const closeNameModal = () => {
    setSelectedName({
      name: "",
      id: "",
    });
    setIsOpenNameModal(false);
  };

  return (
    <>
      <CmsEndpointModal
        id={participantId}
        open={openDetailModal}
        close={closeDetailModal}
      />
      <CmsAddEndpointModal
        open={openAddEndpointModal}
        close={closeAddEndpointModal}
        callId={meetingDetail.CALL_INFO.call_id}
      />

      <NameModal
        value={selectedName}
        isRefresh={getMeetingDetail}
        open={isOpenNameModal}
        close={closeNameModal}
      />

      <CmsLayoutModal
        open={openLayoutModal}
        close={closeLayoutModal}
        isRefresh={getMeetingDetail}
        layout={meetingDetail.layout !== undefined ? meetingDetail.layout : []}
        callId={meetingDetail.CALL_INFO.call_id}
        cospace={
          meetingDetail.cospace_info !== undefined
            ? meetingDetail.cospace_info
            : { id: "", layout: "", activeSpeakerMode: "", fixNum: "" }
        }
        participants={
          meetingDetail.PARTICIPANTS !== undefined
            ? meetingDetail.PARTICIPANTS
            : []
        }
      />

      <Modal
        centered
        className={style.qrpop_full} //모달 ClassName
        open={openPop}
        onCancel={closePop}
        footer={null}
        width="auto"
      >
        <QRCode
          errorLevel="H"
          value={meetingDetail.SCHEDULE_INFO.MEETING_URL}
          icon="https://demo.riv-tech.co.kr/allplace/img/mypage/logo.png"
          iconSize={150}
          size={800}
        />
        <div
          style={{ fontSize: "22px", textAlign: "center", marginTop: "5px" }}
        >
          MEETING URL : {meetingDetail.SCHEDULE_INFO.MEETING_URL}
        </div>
      </Modal>

      <div className={style.wrapper}>
        <div className={style.content_area}>
          <div className={style.header}>
            <div>{t("LABEL.TITLE.MEETING_DETAIL")}</div>
            <div className={style.btn_area}>
              <ConfigProvider
                theme={{
                  token: {
                    fontFamily: "Spoqa Han Sans Neo",
                  },
                  components: {
                    Button: {
                      colorPrimary: "#1677ff",
                      colorPrimaryHover: "#50c1a1",
                      colorPrimaryActive: "#50c1a1",
                    },
                  },
                }}
              >
                <Button
                  size="large"
                  // type="ghost"
                  icon={<ExportOutlined />}
                  onClick={() => navigate(-1)}
                >
                  {t("BTN.BACK_TO_LIST")}
                </Button>
              </ConfigProvider>
              <div className={style.ctrl_btn_area}>
                <ConfigProvider
                  theme={{
                    token: {
                      fontFamily: "Spoqa Han Sans Neo",
                    },
                    components: {
                      Button: {
                        colorPrimary: "#1677ff",
                        colorPrimaryHover: "#50c1a1",
                        colorPrimaryActive: "#50c1a1",
                      },
                    },
                  }}
                >
                  <Button
                    size="large"
                    // type="primary"
                    icon={<ReloadOutlined />}
                    onClick={getMeetingDetail}
                  />
                </ConfigProvider>
                <ConfigProvider
                  theme={{
                    token: {
                      fontFamily: "Spoqa Han Sans Neo",
                    },
                    components: {
                      Button: {
                        colorPrimaryText: "#ffffff",
                        colorTextLightSolid: "#ffffff",
                        colorText: "#ffffff",
                        colorError: "#ff4d4f",
                        colorErrorHover: "#ff7875",
                        colorErrorActive: "#d9363e",
                      },
                    },
                  }}
                >
                  <Button
                    size="large"
                    type="primary"
                    danger
                    icon={<PoweroffOutlined />}
                    onClick={() => {
                      const obj = {
                        title: t("MESSAGE.NOTIFICATION"),
                        content: t("MESSAGE.END_MEETING_CONFIRM"),
                        submitEventHandler: () => {
                          disconnectMeetingRoom();
                          dispatch(closeAlert());
                        },
                      };
                      dispatch(openConfirm(obj));
                    }}
                  >
                    {t("LABEL.MEETING_END")}
                  </Button>
                </ConfigProvider>
              </div>
            </div>
          </div>

          <Descriptions bordered column={2} className={style.meeting_info}>
            <Descriptions.Item label={t("LIST.MEETING_TITLE")} span="2">
              {meetingDetail.SCHEDULE_INFO.TITLE}
            </Descriptions.Item>
            <Descriptions.Item label={t("LIST.MEETING_TIME")}>
              {meetingDetail.SCHEDULE_INFO.START_DATE_TIME === undefined ||
              meetingDetail.SCHEDULE_INFO.END_DATE_TIME === undefined
                ? ""
                : meetingDetail.SCHEDULE_INFO.START_DATE_TIME +
                  " ~ " +
                  meetingDetail.SCHEDULE_INFO.END_DATE_TIME}
            </Descriptions.Item>
            <Descriptions.Item label={t("LIST.CONNECTION_TIME")}>
              {meetingDetail.CALL_INFO.duration === undefined ? (
                ""
              ) : (
                // : moment
                //     .utc(meetingDetail.CALL_INFO.duration)
                //     .tz(meetingDetail.SCHEDULE_INFO.UNLOCODE)
                //     .format("YYYY-MM-DD HH:mm:ss")}
                // : timeFormat(meetingDetail.CALL_INFO.duration)
                <DuraionFormat duration={meetingDetail.CALL_INFO.duration} />
              )}
            </Descriptions.Item>
            <Descriptions.Item label={t("LABEL.WEB_ACCESS_LINK")} span="2">
              <div className={style.meeting_url_area}>
                <a
                  target="_blank"
                  href={meetingDetail.SCHEDULE_INFO.MEETING_URL}
                  rel="noreferrer"
                >
                  {meetingDetail.SCHEDULE_INFO.MEETING_URL}
                </a>

                <CopyToClipboard
                  className="cursor"
                  text={meetingDetail.SCHEDULE_INFO.MEETING_URL}
                  onCopy={() => {
                    const obj = {
                      title: t("MESSAGE.NOTIFICATION"),
                      content: t("MESSAGE.COPY_COMPLETE"),
                      submitEventHandler: () => {
                        dispatch(closeAlert());
                      },
                    };
                    dispatch(openAlert(obj));
                    return;
                  }}
                >
                  <CopyOutlined
                    style={{
                      fontSize: "16px",
                      color: "#d9d9d9",
                    }}
                  />
                </CopyToClipboard>
                <QrcodeOutlined
                  onClick={() => setopenPop(true)}
                  style={{
                    fontSize: "18px",
                    color: "#c0c0c0",
                  }}
                />
              </div>
            </Descriptions.Item>
            <Descriptions.Item label={t("LABEL.ACCESS_NUMBER")}>
              {meetingDetail.SCHEDULE_INFO.MEETING_KEY}
            </Descriptions.Item>
            <Descriptions.Item label={t("LABEL.PASSWORD")}>
              {meetingDetail.SCHEDULE_INFO.MEETING_PW}
            </Descriptions.Item>
          </Descriptions>
        </div>

        <div className={style.content_area}>
          <div className={style.header}>
            <div>{t("LABEL.TITLE.ACCESSED_MEETINGROOM_INFO")}</div>
            <div className={style.btn_meeting_controll_area}>
              <div className={style.btn_meeting_controll}>
                <ConfigProvider
                  theme={{
                    token: {
                      fontFamily: "Spoqa Han Sans Neo",
                    },
                    components: {
                      Button: {
                        // colorPrimary: "#1677ff",
                        colorPrimaryHover: "#50c1a1",
                        colorPrimaryActive: "#50c1a1",
                      },
                    },
                  }}
                >
                  <Button
                    size="large"
                    icon={
                      <AudioMutedOutlined
                        style={{ transform: "scaleX(-1)", color: "#50c1a1" }}
                      />
                    }
                    onClick={() => {
                      const obj = {
                        title: t("MESSAGE.NOTIFICATION"),
                        content: t("MESSAGE.MUTE_ALL_CONFIRM"),
                        submitEventHandler: () => {
                          setMuteAll();
                          dispatch(closeAlert());
                        },
                      };
                      dispatch(openConfirm(obj));
                    }}
                  >
                    {t("BTN.MUTE_ALL")}
                  </Button>
                </ConfigProvider>
                <ConfigProvider
                  theme={{
                    token: {
                      fontFamily: "Spoqa Han Sans Neo",
                    },
                    components: {
                      Button: {
                        // colorPrimary: "#1677ff",
                        colorPrimaryHover: "#50c1a1",
                        colorPrimaryActive: "#50c1a1",
                      },
                    },
                  }}
                >
                  <Button
                    size="large"
                    icon={<AppstoreOutlined style={{ color: "#50c1a1" }} />}
                    onClick={() => setOpenLayoutModal(true)}
                  >
                    {t("BTN.CHANGE_LAYOUT")}
                  </Button>
                </ConfigProvider>
              </div>

              <ConfigProvider
                theme={{
                  token: {
                    fontFamily: "Spoqa Han Sans Neo",
                  },
                }}
              >
                <Button
                  size="large"
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={() => setOpenAddEndpointModal(true)}
                >
                  {t("BTN.ADD_DEVICE")}
                </Button>
              </ConfigProvider>
            </div>
          </div>

          <Table
            rowKey={(record) => record.id}
            className={style.participant_table}
            loading={loading}
            columns={columns}
            pagination={false}
            scroll={{
              y: 403,
            }}
            dataSource={meetingDetail.PARTICIPANTS}
            locale={{ emptyText: <Empty description={t("MESSAGE.NO_DATA")} /> }}
          />
        </div>
      </div>
    </>
  );
}

export default CmsDetail;

function DuraionFormat({ duration }) {
  const { i18n } = useTranslation();
  const [result, setResult] = useState("");
  const setTimer = useCallback(() => {
    ++duration;
    const hour = Math.floor(Number(duration) / 3600);
    const min = Math.floor((Number(duration) % 3600) / 60);
    const second = Math.floor((Number(duration) % 3600) % 60);

    let time = "";
    if (i18n.language === "en-US") {
      time += hour > 0 ? hour + "h " : "";
      time += min > 0 ? min + "m " : "";
      time += second > 0 ? second + "s" : "";
    } else {
      time += hour > 0 ? hour + "시간 " : "";
      time += min > 0 ? min + "분 " : "";
      time += second > 0 ? second + "초" : "";
    }
    setResult(time);
  }, [duration]);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimer();
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [setTimer]);

  return <>{result}</>;
}
